import { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Button from 'components/ui-components/Button';

import { isValidEmail } from 'lib/utils';

import Form from 'components/cef_form/form';
import Input from 'components/cef_form/input';
import Textarea from 'components/cef_form/textarea';

const SpottedMistakeFrom = ({
  RECAPTCHA_SITE_KEY,
  closeModal,
  setFormBody,
  formResponseErrors,
  setFormResponseErrors,
  useRecaptcha,
}) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [formErrors, setFormErrors] = useState({
    name: false,
    email: false,
    message: false,
  });

  const [recaptcha, setRecaptcha] = useState('');
  const [recaptchaError, setRecaptchaError] = useState(false);

  const { name, email, message } = formData;

  const handleChange = e => {
    const { name: eName, value } = e.target;
    setFormData({
      ...formData,
      [eName]: value,
    });

    setFormErrors({
      ...formErrors,
      [eName]: eName === 'email' ? !isValidEmail(value) : !value,
    });

    setFormResponseErrors({
      ...formResponseErrors,
      [eName]: eName === 'email' ? !isValidEmail(value) : !value,
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const recaptchaSuccessful = !!recaptcha || !useRecaptcha;
    const canSubmit =
      isValidEmail(email) && name && message && recaptchaSuccessful;
    const errors = {};

    if (!name) {
      errors.name = true;
    }

    if (!isValidEmail(email)) {
      errors.email = true;
    }

    if (!message) {
      errors.message = true;
    }

    setFormErrors(errors);

    if (!recaptcha) {
      setRecaptchaError(true);
    }

    // submit form if no errors
    if (canSubmit) {
      setFormBody({
        flag_data: {
          name,
          email,
          reason: message,
        },
        'g-recaptcha-response': recaptcha,
      });
    }
  };

  return (
    <>
      <h2 className="ff-body fw-600 fs-32 tc-grey-70 mb-16">
        Spotted a Mistake
      </h2>
      <p className="ff-body tc-grey-70 fs-16 mb-30">
        Please fill in the form below to report a mistake with the product
        information.
      </p>

      <Form className="mb-0" onSubmit={handleSubmit}>
        <div className="fl jc-sb">
          <div className="fb-50 mr-12">
            <Input
              type="text"
              name="name"
              id="sm-name"
              label="Name"
              errorClassName="cef-form__error"
              inputClassName={`spotted-mistake__input plr-8 fs-14 width-100 bs-bb tc-main ${
                (formResponseErrors.name || formErrors.name) &&
                'spotted-mistake__input--has-error'
              }`}
              labelClassName="required-field"
              handleChange={handleChange}
              error={
                (formResponseErrors.name || formErrors.name) &&
                'Please enter your name'
              }
            />
          </div>

          <div className="fb-50 ml-12">
            <Input
              type="email"
              name="email"
              id="sm-email"
              label="Email"
              errorClassName="cef-form__error"
              labelClassName="required-field"
              inputClassName={`spotted-mistake__input plr-8 fs-14 width-100 bs-bb tc-main ${
                (formResponseErrors.email || formErrors.email) &&
                'spotted-mistake__input--has-error'
              }`}
              handleChange={handleChange}
              error={
                (formResponseErrors.email || formErrors.email) &&
                'Please enter a valid email address'
              }
            />
          </div>
        </div>

        <Textarea
          name="message"
          id="sm-message"
          label="Message"
          errorClassName="cef-form__error"
          labelClassName="mt-20 required-field"
          inputClassName={`spotted-mistake__input
          spotted-mistake__textarea p-8 fs-14 width-100 bs-bb tc-main mb-20 ${
            (formResponseErrors.reason || formErrors.message) &&
            'spotted-mistake__input--has-error'
          }`}
          handleChange={handleChange}
          error={
            (formResponseErrors.reason || formErrors.message) &&
            'Please describe the mistake you have found'
          }
        />

        {useRecaptcha && (
          <div className="mt-20 mb-20">
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={val => {
                if (val) {
                  setRecaptcha(val);
                  setRecaptchaError(false);
                }
              }}
            />
            {recaptchaError && (
              <p className="cef-form__error">Please complete ReCAPTCHA</p>
            )}
          </div>
        )}

        <div className="fl ai-ic">
          <Button
            handleClick={closeModal}
            className="cef-btn cef-btn--grey cef-btn--xl fw-600 fs-16 mt-20 mr-8">
            Cancel
          </Button>

          <Button
            type="submit"
            className="cef-btn cef-btn--red cef-btn--xl fw-600 fs-16 mt-20">
            Send Message
          </Button>
        </div>
      </Form>
    </>
  );
};

export default SpottedMistakeFrom;
